import { initExpert } from '../quote/_expert'
import { initRecap } from '../quote/_recap'
import { initQuick } from '../quote/_quick'
import { initFamilies } from '../quote/_families'
import { initFormats } from '../quote/_formats'

// Quote request page (page-templates/page-template-quote.php).
// The modules depend on their order: the expert path preselects a product
// before the families and formats are initialised.
document.addEventListener('DOMContentLoaded', function (e) {
  const quote = e.target.querySelector('.js-quote')

  if (quote && window.vnQuote) {
    // The simple header (stepper) is sticky: the sticky summary sits below it.
    const header = document.querySelector('.js-header-container')
    const setHeaderOffset = () => {
      const offset =
        header && window.innerWidth >= 992 ? header.getBoundingClientRect().bottom : 0
      quote.style.setProperty('--quote-header-offset', `${Math.max(0, offset)}px`)
    }
    setHeaderOffset()
    window.addEventListener('resize', setHeaderOffset)

    initExpert()
    initRecap()
    initQuick(quote)
    initFamilies(quote)
    initFormats()
  }
})
